var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVedaaccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 83.89 34.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:url(#d);}.f{fill:#595959;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 13.71,
    y1: 0,
    x2: 13.71,
    y2: 34.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#90f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f09"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M38.5,24.82l-.52,1.01h-.95l2.21-4.23h.42l2.21,4.23h-.95l-.52-1.01h-1.89Zm1.55-.68l-.62-1.22-.6,1.22h1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M44.4,25.88c-1.45,0-2.39-.91-2.39-2.18s.93-2.16,2.38-2.16c.97,0,1.79,.56,1.92,.63v.91c-.23-.16-.94-.71-1.88-.71s-1.5,.56-1.5,1.34,.58,1.34,1.48,1.34,1.67-.56,1.89-.7v.91c-.11,.09-.91,.63-1.9,.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M49.3,25.88c-1.45,0-2.39-.91-2.39-2.18s.93-2.16,2.38-2.16c.97,0,1.79,.56,1.92,.63v.91c-.23-.16-.94-.71-1.88-.71s-1.5,.56-1.5,1.34,.58,1.34,1.48,1.34,1.67-.56,1.89-.7v.91c-.11,.09-.91,.63-1.9,.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M54.19,25.88c-1.31,0-2.36-.83-2.36-2.18s1.04-2.16,2.36-2.16,2.37,.82,2.37,2.16-1.04,2.18-2.37,2.18h0Zm0-3.52c-.79,0-1.44,.5-1.44,1.34s.66,1.34,1.44,1.34,1.45-.5,1.45-1.34-.66-1.35-1.45-1.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M59.35,25.87c-1.3,0-2.07-.82-2.07-2.13v-2.14h.88v2.14c0,.82,.42,1.3,1.18,1.3s1.19-.49,1.19-1.29v-2.14h.9v2.14c0,1.3-.77,2.12-2.07,2.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M63.37,23.14c0,.08,.02,.26,.02,.43v2.24h-.88v-4.22h.41l2.91,2.73c0-.08-.02-.25-.02-.39v-2.35h.87v4.22h-.42l-2.89-2.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M68.88,25.82v-3.4h-1.52v-.82h3.9v.82h-1.52v3.4h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M72.85,21.61v4.22h-.88v-4.22h.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M74.87,23.14c0,.08,.02,.26,.02,.43v2.24h-.88v-4.22h.41l2.91,2.73c0-.08-.02-.25-.02-.39v-2.35h.87v4.22h-.42l-2.89-2.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M81.5,25.87c-1.54,0-2.42-.99-2.42-2.16s.86-2.16,2.37-2.16c1.13,0,1.84,.53,1.95,.61v.86c-.23-.15-.99-.65-1.93-.65s-1.47,.59-1.48,1.35c0,.77,.59,1.35,1.54,1.35,.37,0,.84-.12,1.09-.29v-1.11h.91v1.52c-.63,.49-1.22,.7-2.01,.7h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M35.56,9.08c.16,0,.23,.04,.28,.16l4.43,7.86c.04,.08,.08,.1,.17,.1h.07c.08,0,.12-.01,.17-.1l4.4-7.86c.06-.11,.12-.16,.28-.16h1.44c.19,0,.23,.12,.14,.28l-4.81,8.57c-.38,.7-.73,.88-1.24,.88h-.67c-.61,0-.96-.18-1.34-.88l-4.86-8.57c-.08-.16-.04-.28,.14-.28h1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M57.42,9.08c.17,0,.25,.08,.25,.25v1.07c0,.18-.08,.26-.25,.26h-6.08c-1.66,0-2.18,.53-2.18,2.21v.32h8.17c.17,0,.25,.07,.25,.25v.89c0,.17-.08,.25-.25,.25h-8.17v.43c0,1.68,.53,2.21,2.18,2.21h6.08c.17,0,.25,.08,.25,.26v1.07c0,.17-.08,.25-.25,.25h-6.09c-2.8,0-3.84-1-3.84-3.66v-2.39c0-2.66,1.06-3.66,3.84-3.66h6.09v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M66.18,9.08c2.99,0,4.2,1.21,4.2,3.91v1.88c0,2.71-1.22,3.91-4.2,3.91h-6.41c-.28,0-.42-.14-.42-.42V9.49c0-.28,.14-.42,.42-.42h6.41Zm-5.11,7.98c0,.11,.06,.17,.17,.17h4.89c1.86,0,2.51-.65,2.51-2.47v-1.61c0-1.82-.65-2.47-2.51-2.47h-4.89c-.11,0-.17,.06-.17,.17v6.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M77.65,9.08c.6,0,.95,.18,1.33,.88l4.86,8.57c.1,.17,.06,.28-.14,.28h-1.42c-.14,0-.2-.04-.28-.16l-1.09-1.96h-7.03l-1.08,1.96c-.06,.11-.12,.16-.28,.16h-1.45c-.18,0-.23-.11-.14-.28l4.82-8.57c.38-.7,.73-.88,1.22-.88h.67Zm-3.04,6.29h5.55l-2.57-4.58c-.06-.08-.1-.1-.17-.1h-.08c-.07,0-.11,.01-.17,.1l-2.57,4.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M25.11,26.56c-.18-.11-.82-.38-1.11-.54,1.22-.61,2.97-3.05,.36-4.69-.48-.25-2.3-.81-2.92,.29-.56,.99,1.21,1.19,1.21,1.19,.1,.47-3.54,2.43-4.63,.88,.38-.99,2.16-3.18,3.41-6.88,.59-1.97,.87-4.22,.66-6.8C21.38,3.99,14.66,.24,8.6,.01,5.15-.12,1.88,.81,.44,3.98c-2.57,7.15,6.94,10.38,9.25,12.16,2.68,2.03,4.07,3.34,4.62,4.84,.43,1.18,.29,2.31,.24,2.61-2.09,.44-3.65-.81-4.28-1.63,.07,.03,1.13,.39,1.47-.32,.05-.11,.62-.94-1.45-1.69-1.48-.21-2.24,.78-2.35,1.5-.14,.65-.18,1.44,1.28,3.18-.99,.2-3.48,.48-4.19,1.22-.71,.74-.36,2.07,.66,2.15,.63,.07,1.69,.07,3.48-.03,1.15-.02,2.27,.2,3.19,.41-.55,.32-1.2,.84-2.3,1.49-.7,.4-1.94,1.66-1.29,2.95,1.16,2.3,5.32-.97,6.8-2.73,.05,1.01,.03,5.12,1.32,4.85,1.46-.3,1.22-4.05,1.19-4.35,.56,.34,1.09,1.59,1.92,1.93,.84,.34,1.24,.28,1.47,.14,.12-.12,1.13-.69-.87-3.29,1.83-.31,5.58,1.6,6.49,1,.34-.11,1.1-2.07-1.97-3.82Zm-6.03-13.41s1.09-1.39,1.23-1.24c.28,0,.63,.45,.7,.7,.28,.84,.41,1.7-.71,2.53-1.41,.97-1.69,.36-1.7,.32-.32-1.14,.47-2.3,.47-2.3h0Zm-4.53,2.99c-.76-.12-1.26-.41-1.68-.92-.43-.6-.66-1.31-.7-2.05-.11-.9,.29-1.6,.79-1.38l1.87,.84c.22,.11,1.2,.64,1.97,2.82,.05,.12-.09,.42-.53,.61-.4,.17-1.03,.18-1.74,.07h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVedaaccounting);
export default __webpack_public_path__ + "static/media/vedaaccounting.5e25800a65e7752d13241e64139455f0.svg";
export { ForwardRef as ReactComponent };